var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"striped":"","hover":"","selectable":true,"select-mode":"single","items":_vm.items,"fields":_vm.tableFields},on:{"row-selected":_vm.onRowSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }